export const activeUploadGuids = (uploadCounts = {}, evaporateIdsByUploadGuid = {}) => {
    const uploadGuids = new Set(
        Object.entries(uploadCounts)
            .filter(([, count]) => count > 0)
            .map(([guid]) => guid)
    )

    Object.entries(evaporateIdsByUploadGuid).forEach(([guid, evaporateIds]) => {
        if(evaporateIds?.size > 0) uploadGuids.add(guid)
    })

    return [...uploadGuids]
}

export const shouldStopForCancellation = (uploadState, allowedAfterCancellation = false) => (
    uploadState === 'cancelled' && !allowedAfterCancellation
)

// Fields written by asset processing (AssetDataVersion#broadcast_to_upload).
// The set_uploaded response is serialized before processing, so for small
// files it can arrive after these were broadcast and would regress them.
export const PROCESSING_OWNED_ASSET_FIELDS = [
    'aasm_state', 'thumb_url', 'grid_url', 'small_url', 'permalink_url', 'full_url', 'original_url',
    'has_alpha', 'width', 'height', 'submitted', 'submitted_at', 'time_to_process',
    'processing_finished_at', 'processing_error', 'data_version_number',
]

export const withoutProcessingFields = (asset = {}) => {
    const rest = {...asset}
    PROCESSING_OWNED_ASSET_FIELDS.forEach(field => delete rest[field])
    return rest
}
